import React from "react";
import PageContent from "../../../layout/PageContent";
import Page from "../../../layout/Page";
import {useParams} from "react-router-dom";
import {LinearProgress} from "@mui/material";
import {useShippingBrandsQuery, useShippingCarrierEditQuery, useShippingCarrierUpdateMutation} from "../../../Queries";
import {ShippingCarrierForm, ShippingCarrierFormData, CarrierEnum} from "./ShippingCarrierForm";

export const ShippingCarrierEditPath = (id: string) => {
   return "/admin/shippingcarriers/" + id
}
export const ShippingCarrierEdit = () => {
   const {shippingCarrierId} = useParams<{ shippingCarrierId: string }>()
   const {data} = useShippingCarrierEditQuery({
      variables: {
         id: shippingCarrierId
      }
   });
   const {data: brands} = useShippingBrandsQuery();
   const [update] = useShippingCarrierUpdateMutation();

   if (!data || !brands) {
      return <LinearProgress/>
   }

   const shippingCarrier = data.ShippingCarrier

   const mapToFormData = (carrier: typeof shippingCarrier): ShippingCarrierFormData | undefined => {
      if (!carrier) return undefined;
      
      return {
         _id: carrier._id,
         logo: carrier.logo || undefined,
         name: carrier.name || '',
         carrier: carrier.carrier || undefined,
         carrierId: (carrier.carrierId as any) || CarrierEnum.shipmondo,
         description: carrier.description || '',
         externalName: carrier.externalName || '',
         externalCode: carrier.externalCode || '',
         expression: carrier.expression || undefined,
         activeFor: carrier.activeFor || [],
         localizationKey: carrier.localizationKey || undefined,
         shipmondo: carrier.shipmondo ? {
            ownAgreement: carrier.shipmondo.ownAgreement || undefined,
            testMode: carrier.shipmondo.testMode || undefined,
            carrier: carrier.shipmondo.carrier || undefined,
            carrierSecondary: carrier.shipmondo.carrierSecondary || undefined,
            carrierCode: carrier.shipmondo.carrierCode || undefined,
            serviceCodes: carrier.shipmondo.serviceCodes || undefined,
            customerNumber: carrier.shipmondo.customerNumber || undefined,
            qrX: carrier.shipmondo.qrX || undefined,
            qrY: carrier.shipmondo.qrY || undefined,
            qrSize: carrier.shipmondo.qrSize || undefined,
            width: carrier.shipmondo.width || undefined,
            height: carrier.shipmondo.height || undefined,
            length: carrier.shipmondo.length || undefined,
            description: carrier.shipmondo.description || undefined,
            customs: carrier.shipmondo.customs || undefined,
         } : undefined,
         carrierGateway: carrier.carrierGateway ? {
            apiKey: carrier.carrierGateway.apiKey!,
            inputCarrier: carrier.carrierGateway.inputCarrier!,
            outputCarrier: carrier.carrierGateway.outputCarrier!,
            supportQR: carrier.carrierGateway.supportQR!
         } : undefined,
         customCarrier: carrier.customCarrier || undefined,
      };
   };

   const handleSubmit = async (formData: ShippingCarrierFormData) => {
      await update({
         variables: {
            id: shippingCarrierId,
            input: formData
         }
      });
   }

   return <Page>
      <PageContent>
         <ShippingCarrierForm 
            initialData={mapToFormData(shippingCarrier)}
            brands={brands.BrandHouses || []}
            onSubmit={handleSubmit}
         />
      </PageContent>
   </Page>
}
